import { Injectable } from '@angular/core';
import { ICloudinaryService } from '@smsamiinc/catalog';

import { environment } from '../../../environments/environment';

/**
 * Cloudinary service implementation for webapp-pos
 *
 * Provides Cloudinary configuration from environment for image uploads
 * and default image URLs.
 */
@Injectable({ providedIn: 'root' })
export class CloudinaryService implements ICloudinaryService {
    /**
     * Get Cloudinary configuration for image uploads
     * Used by plugins for uploading images to Cloudinary
     */
    getCloudinaryConfig(): { cloudName: string; uploadPreset: string } {
        return {
            cloudName: environment.cloudinary.cloud_name,
            uploadPreset: environment.cloudinary.company_preset,
        };
    }

    /**
     * Get default image URL (Cloudinary public ID)
     * Returns the public ID path for default images in Cloudinary
     */
    getDefaultImageUrl(): string {
        // Return the public ID path (without the full URL)
        return 'pos-uat/app-images/default-img';
    }
}
